<div class="common-modal__container">
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'process.edit.properties.process-title'">
        _proceso
    </span>
  </div>
  @if(processEditModal.showHeaderInfo){
    <div class="common-status-message__g-container-warning">
      <i class="lf-icon-warning-full common-status-message__icon-md"></i>
      <div class="common-status-message__g-content">
          <div class="common-status-message__g-icon-text-content">
            <div class="common-status-message__g-title-subtitle">
              <span class="common-status-message__g-subtitle"
              [afTranslate]="'process.edit.redesign-concept'">
                _Este proceso ya se está aplicando. Los cambios podrían afectar a otras configuraciones (tarea de gestión, alertas, asociación de documentos, notificaciones...)
              </span>
            </div>
            <button class="common-button__icon-xs-noborder"
                (click)="processEditModal.showHeaderInfo = !processEditModal.showHeaderInfo">
                <i class="lf-icon-close-thick common-icon__sm"></i>
            </button>
          </div>
          @if(concept.productTypeId === 2 && !concept.poll){
            <div class="common-status-message__g-buttons-container">
              <button class="common-button__link"
                (click)="processEditModal.showHeaderInfo = false">
                <span class="common-button__link-text"
                  [afTranslate]="'customize-concept.redesign-concept'">_Desbloquear y rediseñar concepto</span>
              </button>
            </div>
          }
      </div>
    </div>
  }
  <process-edit [evaluationId]="evaluationId" 
    [concept]="concept" 
    [modal]="true" 
    (onUpdate)="processUpdated($event)">
  </process-edit>
  <div>
    <div class="process-edit__buttons-container">
      @if(processEditModal.isNew){
        <button class="common-button__text-noborder"
          (click)="deleteProcess()">
          <span class="common-button__text-title"
            [afTranslate]="'process.edit.delete'">
            _Eliminar proceso
          </span>
        </button>
      }
      <button class="common-button__text-border"
        (click)="cancel()">
        <span class="common-button__text-title"
          [afTranslate]="'common.cancel'">_cancelar</span>
      </button>
      <button
        class="common-button__text"
        (click)="saveProcess()">
        <span class="common-button__text-title">
          {{(processEditModal.isNew ? 'common.save' : 'process-edit.save-process') | afTranslate }}
        </span>
      </button>
    </div>
  </div>
</div>


<!-- <div class="process-edit-modal">
    <div class="common__modal-header-block common__modal-header-block--margin-0">
        <i class="lf-icon-process common__icon-header"></i>
        <span class="common__text-header" [afTranslate]="'process.title'"></span>
        <i class="lf-icon-close common__icon-close-modal" (click)="handleDismiss()"></i>
    </div>
    <main class="process-edit-modal__main">
       
    </main>
  <footer class="process-edit-modal__footer">
      <div class="process-edit__howto pull-left">
        <div class="process-edit__howto"
            [ngShow]="!processEditModal.modal">
            <i class="customize-concept__info-block-icon"
                [ngClass]="processEditModal.showInfo?'lf-icon-close-round':'lf-icon-information'"
                (click)="processEditModal.showInfo = !processEditModal.showInfo"></i>
            <div class="customize-concept__triangle-box"
                    [ngShow]="processEditModal.showInfo"></div>
            <div class="customize-concept__info-block"
                    [ngClass]="{'customize-concept__info-block--open':processEditModal.showMoreInfo}"
                    [ngShow]="processEditModal.showInfo">
                <p class="customize-concept__info-block-title"
                    [afTranslate]="'process.edit.how-to'">¿Como diseñar un proceso?</p>
                <ul class="customize-concept__info-steps-block">
                    <li class="customize-concept__info-step">
                        <i class="lf-icon-number-one customize-concept__icon-step"></i>
                        <span [afTranslate]="'process.edit.how-to-1-title'">Definir el proceso</span>
                    </li>
                    <li class="customize-concept__info-step">
                        <i class="lf-icon-number-two customize-concept__icon-step"></i>
                        <span [afTranslate]="'process.edit.how-to-2-title'">Definir estados</span>
                    </li>
                    <li class="customize-concept__info-step">
                        <i class="lf-icon-number-three customize-concept__icon-step"></i>
                        <span [afTranslate]="'process.edit.how-to-3-title'">Definir transiciones</span>
                    </li>
                    <li class="customize-concept__info-step">
                        <i class="lf-icon-number-four customize-concept__icon-step"></i>
                        <span [afTranslate]="'process.edit.how-to-4-title'">Finalizar</span>
                    </li>
                </ul>
            </div>
        </div>
      </div>
      <button type="submit" class="common__button common__button--active float-end"
          (click)="handleDismiss()"
          [afTranslate]="'common.finish'"></button>
  </footer>
</div> -->
